export const REFERRAL_REFRESH = "REFERRAL_REFRESH"
export const REFERRAL_REFRESH_SUCCESS = "REFERRAL_REFRESH_SUCCESS"